import type { CancelablePromise } from 'src/api/generated';

/**
 * Connects TanStack Query's abort signal to the generated API client's
 * cancelable request.
 *
 * @param request - Generated API request to await and cancel.
 * @param signal - TanStack Query abort signal for the active query.
 * @returns The generated request result.
 * @throws The original generated-client error when the request fails.
 */
export const awaitCancelableRequest = async <T>(
  request: CancelablePromise<T>,
  signal: AbortSignal
): Promise<T> => {
  const cancelRequest = (): void => request.cancel();

  if (signal.aborted) {
    cancelRequest();
  } else {
    signal.addEventListener('abort', cancelRequest, { once: true });
  }

  try {
    return await request;
  } finally {
    signal.removeEventListener('abort', cancelRequest);
  }
};
